export default __webpack_public_path__ + "static/media/17-SkodaAuto-Logo2.7904ebb2.jpg";